import getMostRelevantProfile from './getMostRelevantProfile';
import { Profile } from '../components/Jobs/JobDetail/JobProperties';

const getEbpSpotlightProfile = (
  company: {
    name: string;
    imageUrls: (string | null)[];
    logoUrls: (string | null)[];
  },
  profiles: Profile[],
) => {
  const {
    name: companyName,
  } = company;

  const ebpSpotlightProfiles = profiles.filter(
    ({ hasTabs, page: { premium } }) => (hasTabs && premium),
  );

  return getMostRelevantProfile(
    ebpSpotlightProfiles, companyName,
  )[0];
};

export default getEbpSpotlightProfile;
